import { DataToolsComponent } from './../components/dmi/dmi-tools/data-tools/data-tools.component';
import { DmiLandingComponent } from './../mapps/dmi/dmi-landing/dmi-landing.component';
import { DmiSubnavService } from './../components/dmi/dmi-model/services/dmi-subnav.service';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WmsConfigComponent } from './../mapps/dmi-pages/data/wms/wms-config/wms-config.component';
import { UiElementsModule } from './ui-elements.module';
import { ArcgisConfigComponent } from '../mapps/dmi-pages/data/arcgis/arcgis-config/arcgis-config.component';
import { ViewStackViewUnencapsulatedComponent } from '../components/view-stack/view-stack-view-unencapsulated/view-stack-view-unencapsulated.component';
import { MenuTesterComponent } from '../components/dmi/menu-tester/menu-tester.component';
import { DmiToolsComponent } from '../components/dmi/dmi-tools/dmi-tools.component';

@NgModule({
  declarations: [
    WmsConfigComponent,
    ArcgisConfigComponent,
    DmiLandingComponent,
    MenuTesterComponent,
    DmiToolsComponent,
    DataToolsComponent

  ],
  imports: [
    CommonModule,
    FormsModule,
    UiElementsModule,
  ],
  providers: [
    DmiSubnavService
  ],
  exports: [
    DmiLandingComponent,
    WmsConfigComponent,
    ArcgisConfigComponent,
    MenuTesterComponent,
    DmiToolsComponent,
    DataToolsComponent
  ]
})
export class DmiCommonModule { }
